// extracted by mini-css-extract-plugin
export var hidden = "_oz-1";
export var visible = "_oz-0";